/**
 * INVENTA API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ShareDto } from './shareDto';
import { DeploymentDto } from './deploymentDto';


export interface AnimalDashboardDto { 
    id: number;
    label?: string;
    shares: Array<ShareDto>;
    name: string;
    description?: string;
    color?: string;
    animalSex?: AnimalDashboardDto.AnimalSexEnum;
    deployments?: Array<DeploymentDto>;
    lastReception?: string;
    lastPosMainV?: number;
    lastPosAcqTime?: string;
    lastPosMortStatus?: AnimalDashboardDto.LastPosMortStatusEnum;
    networkStatus?: AnimalDashboardDto.NetworkStatusEnum;
    dateOfDeath?: string;
    accessOnlyFromCollar: boolean;
    animalSpeciesId?: string;
}
export namespace AnimalDashboardDto {
    export const AnimalSexEnum = {
        Male: 'MALE',
        Female: 'FEMALE',
        Unknown: 'UNKNOWN'
    } as const;
    export type AnimalSexEnum = typeof AnimalSexEnum[keyof typeof AnimalSexEnum];
    export const LastPosMortStatusEnum = {
        NotAvailable: 'NOT_AVAILABLE',
        NothingDetected: 'NOTHING_DETECTED',
        LowActivityNoRadius: 'LOW_ACTIVITY_NO_RADIUS',
        LowActivityInsideRadius: 'LOW_ACTIVITY_INSIDE_RADIUS',
        LowActivityOutsideRadius: 'LOW_ACTIVITY_OUTSIDE_RADIUS',
        MortalityNoRadius: 'MORTALITY_NO_RADIUS',
        MortalityInsideRadius: 'MORTALITY_INSIDE_RADIUS',
        MortalityOutsideRadius: 'MORTALITY_OUTSIDE_RADIUS'
    } as const;
    export type LastPosMortStatusEnum = typeof LastPosMortStatusEnum[keyof typeof LastPosMortStatusEnum];
    export const NetworkStatusEnum = {
        Activating: 'ACTIVATING',
        Activated: 'ACTIVATED',
        Deactivating: 'DEACTIVATING',
        Deactivated: 'DEACTIVATED',
        Suspending: 'SUSPENDING',
        Resuming: 'RESUMING',
        Changing: 'CHANGING',
        Invalid: 'INVALID',
        Changed: 'CHANGED'
    } as const;
    export type NetworkStatusEnum = typeof NetworkStatusEnum[keyof typeof NetworkStatusEnum];
}


export type AnimalSexEnum = typeof AnimalDashboardDto.AnimalSexEnum[keyof typeof AnimalDashboardDto.AnimalSexEnum];
export type LastPosMortStatusEnum = typeof AnimalDashboardDto.LastPosMortStatusEnum[keyof typeof AnimalDashboardDto.LastPosMortStatusEnum];
